import { render, staticRenderFns } from "./PpvTrackSection.vue?vue&type=template&id=c8062042&scoped=true"
import script from "./PpvTrackSection.vue?vue&type=script&lang=js"
export * from "./PpvTrackSection.vue?vue&type=script&lang=js"
import style0 from "./PpvTrackSection.vue?vue&type=style&index=0&id=c8062042&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8062042",
  null
  
)

export default component.exports